import React, { useEffect, useState } from 'react';
import { authActions, loginUser } from './store/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { userApi } from './store/services/userServices';
import { jwtDecode } from 'jwt-decode';
import { alertActions } from './store/alertSlice';
import { getRoleNames } from './utils/roleUtils';
import { useGetRolesQuery } from './store/services/rolesServices';

const Login = () => {
  const dispatch = useDispatch();
  const { data: rolesData } = useGetRolesQuery();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const token = useSelector(state => state.auth.token)

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    const credentials = {
      email,
      password,
    };
    dispatch(loginUser(credentials))
      .unwrap()
      .then((response) => {
        console.log(jwtDecode(response?.data.access_token))
        // don't save the token in the local storage if user doesn't have a valid role
        const userRole = jwtDecode(response?.data.access_token).role;
        console.log({ userRole })

        const validRoles = getRoleNames(rolesData?.data);
        console.log({ validRoles })
        if (!validRoles.includes(userRole)) {
          dispatch(alertActions.openModal({ text: "You don't have permission to access the dashboard", type: 'error' }))
          setIsLoading(false);
          return;
        }
        localStorage.setItem('giz_superaccess', response?.data.access_token);
        localStorage.setItem('giz_superrefresh', response?.data.refresh_token);
        navigate('/')
      })
      .catch((error) => {
        console.error('Login failed:', error?.message);
        setError(
          error?.code === 'account_inactive'
            ? 'This account has been deactivated. Please contact an administrator.'
            : 'Wrong credentials'
        );
        setIsLoading(false);
      });
  };

  return (
    <div className="min-h-dvh flex items-center justify-center bg-gradient-to-b from-gray-50/60 via-white to-white px-4 py-10">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src="/pics/atk-long.svg" alt="ATK" className="w-52 sm:w-60" />
        </div>

        <div className="rounded-2xl border border-gray-200 bg-white shadow-sm p-6 sm:p-8">
          <div className="mb-6">
            <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">
              Sign in
            </h1>
            <p className="mt-1 text-sm text-gray-500">
              Enter your credentials to access the dashboard.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div>
              <label className="block text-gray-600 text-sm font-semibold mb-1.5" htmlFor="email">
                Email
              </label>
              <input
                type="email"
                id="email"
                className="w-full rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 outline-none transition-colors focus:outline-none focus:border-secondary/50 focus:ring-4 focus:ring-secondary/10"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <div className="flex items-center justify-between mb-1.5">
                <label className="block text-gray-600 text-sm font-semibold" htmlFor="password">
                  Password
                </label>
                <Link to="/forgot-password" className="text-xs font-semibold text-secondary hover:underline">
                  Forgot password?
                </Link>
              </div>
              <input
                type="password"
                id="password"
                className="w-full rounded-xl border border-gray-200 bg-white px-4 py-2.5 text-sm text-gray-900 placeholder:text-gray-400 outline-none transition-colors focus:outline-none focus:border-secondary/50 focus:ring-4 focus:ring-secondary/10"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>

            {error && (
              <p className="rounded-xl border border-red-200 bg-red-50 px-4 py-2.5 text-center text-sm font-medium text-red-600">
                {error}
              </p>
            )}

            <button
              type="submit"
              disabled={isLoading}
              className="mt-1 w-full rounded-xl bg-primary px-4 py-2.5 text-sm font-bold text-white shadow-sm transition-all hover:brightness-110 active:scale-[0.99] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading ? (
                <>
                  <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  <span>Signing in...</span>
                </>
              ) : (
                'Sign in'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login